import { RequestReferencePayment } from 'src/app/domain/models/paymentLink/request-referencePayment';
import { Observable } from 'rxjs';

export abstract class ReferencePaymentGateway {
    abstract getReferencePayment(requestReferencePayment: RequestReferencePayment): Observable<any>;
}